import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { UPDATE_PRODUCT } from './consts/types';

export const updateProduct = createTaskAction(
  UPDATE_PRODUCT,
  undefined,
  task => task.productId,
);
